/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import { Chip, Stack } from '@mui/material'
import { Filters, UseFiltersInstanceProps } from 'react-table'
import { BLANK_VALUE_LABEL } from '../FilterTool/Filters/SingleSelectFilter'
import { SimpleMap } from '@vendorflow/types'

const PADDING = 24

interface Props<D extends object> {
  columnNameById: SimpleMap<string>
  filters: Filters<D>
  setFilter: UseFiltersInstanceProps<D>['setFilter']
}

export default function AppliedFilters<D extends object>({ columnNameById, filters, setFilter }: Props<D>) {
  if (!filters.length) {
    return null
  }

  return (
    <Stack
      direction="row"
      overflow="none"
      css={css`
        width: calc(100% - ${PADDING * 2}px);
        padding: 8px ${PADDING}px;
        flex-wrap: wrap;
        gap: 0.25rem 0.25rem;
      `}
    >
      {filters
        .filter(
          (filter) =>
            (Array.isArray(filter.value) && !!filter.value.length) ||
            (!Array.isArray(filter.value) && filter.value != null)
        )
        .map((filter) => (
          <Chip
            key={filter.id}
            label={`${columnNameById[filter.id]}: ${filter.value === '' ? BLANK_VALUE_LABEL : filter.value}`}
            onDelete={() => setFilter(filter.id, null)}
          />
        ))}
    </Stack>
  )
}
